import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cuánto tiempo tarda mi página web?',
    a: 'Landing page: 5-7 días hábiles\nSitio web para negocio: 10-15 días hábiles\nWeb para negocio Plus: 15-20 días hábiles'
  }, {
    q: '¿Necesito saber de tecnología?',
    a: 'Para nada. Nosotros nos encargamos de todo. Tú solo nos das la información de tu negocio y nosotros hacemos el resto.'
  }, {
    q: '¿Mi página funciona en celular?',
    a: 'Sí. El 90% de tus clientes te buscan desde el celular. Todas nuestras páginas están optimizadas para móvil.'
  }, {
    q: '¿Qué necesito para empezar?',
    a: 'Solo necesitas contarnos sobre tu negocio. Si tienes fotos o logo, mejor. Si no, nosotros te ayudamos.'
  }, {
    q: '¿Puedo actualizar mi página después?',
    a: 'Sí. Los cambios y actualizaciones posteriores se cotizan por separado según lo que necesites.'
  }, {
    q: '¿Tienen soporte después de entregar?',
    a: 'Todos los planes incluyen soporte inicial. El soporte mensual o puntual se puede contratar por separado.'
  }, {
    q: '¿No sé cuál plan elegir, qué hago?',
    a: 'Escríbenos por WhatsApp y te asesoramos gratis. Sin compromiso.\nWhatsApp: 3508108717'
  }];
  return <section className="py-32 bg-nova-bg-alt" data-id="element-126">
      <div className="max-w-3xl mx-auto px-6" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-bold text-nova-text" data-id="element-129">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-[3px] bg-nova-accent mx-auto mt-4" data-id="element-130" />
        </motion.div>

        <div className="space-y-4" data-id="element-131">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-nova-card rounded-xl overflow-hidden border border-nova-bg-alt" data-id="element-132">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-133">
                <span className="font-semibold text-nova-text" data-id="element-134">{faq.q}</span>
                <ChevronDown className={`text-nova-accent transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-135" />
              </button>

              <AnimatePresence data-id="element-136">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-137">
                    <div className="px-6 pb-4 pt-2 border-t border-nova-accent/20" data-id="element-138">
                      <p className="text-nova-text-muted whitespace-pre-line" data-id="element-139">
                        {faq.a.includes('3508108717') ? <>
                            {faq.a.split('3508108717')[0]}
                            <a href="https://wa.me/573508108717" className="text-nova-accent hover:underline" data-id="element-140">
                              3508108717
                            </a>
                          </> : faq.a}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}